import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import PageSubHeader from "./PageSubHeader";

export interface PageContentProps {
    titles?: string[];
}

class PageContent extends React.PureComponent<PageContentProps & WithStyles<typeof styles>> {

    render() {
        const { titles, classes, children } = this.props;
        return <div>
            {titles && titles.length > 0 ? <PageSubHeader titles={titles} /> : null}
            <div className={classes.content}>{children}</div>
        </div>;
    }
}


export const styles = (theme: Theme) => createStyles({
    content: {
        padding: 2 * theme.spacing.unit,
    },
});

export default withStyles(styles)(PageContent);